import React, {useState, useCallback} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col, Container, H4} from '@modifi/ui'

import {DefaultComponentWrapper} from '../common'
import DefaultCarousel from '../../common-components/default-carousel'
import USPCard from './USPCard'
import {StyledTabsPure} from './styles'
import {StyledH4} from '../headline-with-description/styles'

const propTypes = {
  'tab-1': PropTypes.string.isRequired,
  'tab-2': PropTypes.string,
  'tab-3': PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      description: PropTypes.string,
      icon: PropTypes.string,
      tab: PropTypes.oneOf(['tab-1', 'tab-2', 'tab-3']),
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
  isSmHeadlineOnLgOrLower: PropTypes.bool,
}
const defaultProps = {
  'tab-2': undefined,
  'tab-3': undefined,
  backgroundColor: undefined,
  isSmHeadlineOnLgOrLower: false,
}
type TabItemType = {
  label: string
  key: string
  disabled: boolean
}

export type TabularUSPsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const TabularUSPs: React.FC<TabularUSPsProps> = props => {
  const {
    'tab-1': tab1Label,
    'tab-2': tab2Label,
    'tab-3': tab3Label,
    cards,
    backgroundColor,
    isSmHeadlineOnLgOrLower,
  } = props

  const tabItems = [tab1Label, tab2Label, tab3Label].reduce((final, item, index) => {
    if (item) {
      final.push({label: item!, key: `tab-${index + 1}`, disabled: false})
    }
    return final
  }, [] as TabItemType[]) as TabItemType[]

  const [selectedTab, setSelectedTab] = useState(tabItems?.[0]?.key)

  const handleTabClick = useCallback((val: any, key: any): void => setSelectedTab(key), [])

  const selectedCardItems = cards?.filter(card => card?.tab === selectedTab)

  const updatedTabItems = tabItems.map(item => ({
    ...item,
    label: item?.label?.split(' ').join('\n'),
  }))

  const headline = isSmHeadlineOnLgOrLower ? (
    <StyledH4>{tabItems?.[0]?.label}</StyledH4>
  ) : (
    <H4>{tabItems?.[0]?.label}</H4>
  )

  return (
    <DefaultComponentWrapper backgroundColor={backgroundColor}>
      <Container>
        <Row justifyContent="center">
          <Col col="auto">
            {tabItems.length > 1 ? (
              <StyledTabsPure
                options={updatedTabItems}
                activeTab={selectedTab}
                // @ts-expect-error to be fixed
                theme="primary"
                transparent
                onTabClick={handleTabClick}
                collapse
              />
            ) : (
              headline
            )}
          </Col>
        </Row>
        <Row mt={40} mdMt={72}>
          <Col>
            <DefaultCarousel indicatorPosition="left" cardAlignment="center" key={selectedTab}>
              {selectedCardItems.map((selectedCardItem, idx) => (
                <USPCard
                  cardDetails={selectedCardItem!}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${selectedCardItem?.headline}-${idx}`}
                />
              ))}
            </DefaultCarousel>
          </Col>
        </Row>
      </Container>
    </DefaultComponentWrapper>
  )
}

TabularUSPs.propTypes = propTypes

TabularUSPs.defaultProps = defaultProps

export default TabularUSPs
